import React from 'react';
import programelogo from '../../Assets/pr-image-two.svg';
import prlogotwo from '../../Assets/15 7 1.svg';
import prlogothree from '../../Assets/primg.svg';
import prlogofour from '../../Assets/prlogo.svg';
import playimage from '../../Assets/p.svg'
import AOS from "aos";
import { useEffect } from 'react';
import "aos/dist/aos.css";


const Programes = () => {

	useEffect(() => {
		AOS.init({
		  disable: "phone",
		  duration: 700,
		//   easing: "ease-out-cubic",
		});
	  }, []);


  return (
		<div className='overall-main'>
		  <div className='programes-main'>
        <div className="container-main">
            <div className="row">
              <div className="col-lg-4">
								<div className="text-dv-prgrames">
									<h1 className='programe-heading'>Our <span className='programe-block-text'>Programs</span></h1>
								</div>
							</div> 
							<div className="col-lg-2 col-6">
								<div className="programe-logo">
									<img src={programelogo} className='logo-pr' alt="" />
								</div>
							</div>
							<div className="col-lg-2 col-6 ">
								<div className="programe-logo">
									<img src={prlogotwo} className='logo-pr' alt="" />
								</div>
							</div>
							<div className="col-lg-2 col-6 ">
								<div className="programe-logo">
									<img src={prlogothree} className='logo-pr' alt="" />
								</div>
							</div>
							<div className="col-lg-2 col-6 ">
								<div className="programe-logo">
									<img src={prlogofour} className='logo-pr' alt="" />
								</div>
							</div>
            </div>
        </div>
    	</div>
			<div className='counter-main'>
				<div className="container-main">
					<div className="row">
						<div className="play-vedio" data-aos="zoom-in">
							<img src={playimage} className='playimage-main' alt="" />
							{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
							<a id="play-video" className="video-play-button" href="#"  data-toggle="modal" data-target="#savoybeachhotel">
								<span></span>
							</a>
						</div>
					</div>
					<div className="counterss">
						<div className="row">
							<div className="col-lg-3 col-6">
								<div className="counter-items">
									<h1 className='counter-text-number'>100+</h1>
									<p className='counter-number-sub-text'>Active Students</p>
								</div>
							</div>
							<div className="col-lg-3 col-6">
								<div className="counter-items">
									<h1 className='counter-text-number'>20+</h1>
									<p className='counter-number-sub-text'>Faculties</p>
								</div>
							</div>
							<div className="col-lg-3 col-6">
								<div className="counter-items">
									<h1 className='counter-text-number'>10+</h1>
									<p className='counter-number-sub-text'>Programmes </p>
								</div>
							</div>
							<div className="col-lg-3 col-6">
								<div className="counter-items">
									<h1 className='counter-text-number'>15+</h1>
									<p className='counter-number-sub-text'>Activities</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>	
	</div>
  )
}

export default Programes